export default __webpack_public_path__ + "static/media/left-shape.5145394f.png";